import { render, staticRenderFns } from "./ValidateModal.vue?vue&type=template&id=bad73d8a&scoped=true&"
import script from "./ValidateModal.vue?vue&type=script&lang=js&"
export * from "./ValidateModal.vue?vue&type=script&lang=js&"
import style0 from "./ValidateModal.vue?vue&type=style&index=0&id=bad73d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad73d8a",
  null
  
)

export default component.exports